import React from 'react'

import withStyles, { WithStyles } from '@material-ui/core/styles/withStyles';
import { Theme } from '@material-ui/core/styles';

import Box from '@material-ui/core/Box';
import Fab from '@material-ui/core/Fab';

import LinkIcon from '@material-ui/icons/Link';

import IViewQueryParams from './IViewQueryParams';

import { CopyToClipboard } from 'react-copy-to-clipboard';

const styles = (theme: Theme) => ({
  fabRoot: {
    minWidth: '270px',
    fontSize: '1.2rem'
  },  
  extendedIcon: {
    marginRight: theme.spacing(1),
  }
});


interface Props {
  queryParams: IViewQueryParams;
}

interface State { 
}

type PropsWithStyles = Props & WithStyles<'fabRoot' | 'extendedIcon'>;

class ShareButton extends React.Component<PropsWithStyles, State> {

  render() {
    const { classes } = this.props;

    return (     
      <Box my={2} textAlign="center">
        <CopyToClipboard text={this.getUrlForCopyToClipboard()}>
          <Fab 
            color="primary"
            classes={{
              root: classes.fabRoot
            }}
            variant="extended" 
            size="large" 
            id="share-button"
          >
            <LinkIcon className={classes.extendedIcon} />  Copy link
          </Fab>

        </CopyToClipboard>
      </Box>
    );
  }

  getUrlForCopyToClipboard = () => {
    const { queryParams } = this.props;
    if(queryParams.changeShareBtn) {
      window.parent.postMessage(['changeShareBtn', true], '*');
      return (
        `https://wideo.co/your-screen-recording?videoId=${queryParams.videoId}`
      )      
    } else {
      return (
        `${window.location.host}/view?videoId=${queryParams.videoId}`
      ) 
    }
   
  }    

  }

export default withStyles(styles)(ShareButton);  